import { ODataSelect } from "@iconics/core";
import { NotificationAreaEnum, NotificationRuleAttachmentTypeEnum } from '@iconics/providers.fadx-platform-api-client-v2';

export class NotificationData extends ODataSelect
{
    public Id = 0;
    public Name = '';
    public EventTypeName? = '';
    public RuleExpression? = '';
    public Disabled = false;
    public ShouldSendMail = false;
    public ShouldSendMobilePush = false;
    public To? = '';
    public Cc? = '';
    public Bcc? = '';
    public Message = '';
    public ReplyTo? = '';
    public Subject? = '';
    public IsHTML = false;
    public MobilePushTo? = '';
    public MobilePushTitle? = '';
    public MobilePushMessage? = '';
    public NotificationArea: NotificationAreaEnum = 'Generic';
    public MobilePushAction? = '';
    public MobilePushBadge? = '';
    public MobilePushActionUri? = '';
    public AttachmentType: NotificationRuleAttachmentTypeEnum = 'None';
    public ShouldSendTwilio = false;
    public TwilioTo? = '';
    public TwilioMessage? = '';
    public '@odata.etag' = '';

    public toSelect(): string
    {
        return '';
    }
}
